/* eslint-disable */
// Base URL for order-app-backend (the NestJS/MongoDB service that owns
// FoorCall confirmer-order tracking and billing — see its own CLAUDE.md).
// No global prefix on that server (see order-app-backend/src/main.ts), so
// routes are called directly, e.g. `${ORDER_APP_BACKEND_URL.production}/billing/...`.
// Mirrors the dev/production shape already used by constants/server_url.js.
export const ORDER_APP_BACKEND_URL = {
  development: "http://localhost:3000",
  production: "https://lobster-app-7227t.ondigitalocean.app",
};
